// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApproverUserDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { AssetInfoFragmentDoc } from '../../../projects/assets/AssetPreview.generated';
export type ApprovalSubject_BillFragment = { __typename?: 'Bill', id: string, name: string, amountInCents: number, internalNote?: string | null | undefined, blueprintUrl: { __typename?: 'Url', path: string }, predictedApprovers: Array<
    | { __typename?: 'Client', id: string, name: string }
    | { __typename?: 'InternalUser', id: string, avatar: string, name: string }
    | { __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }
  >, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  , type: { __typename?: 'BillTypeDetail', name: string, code: Types.BillType }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<
    | { __typename?: 'Commitment', id: string, accountingNumber: number }
    | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number }
  >, lineItems: Array<{ __typename?: 'BillLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string, fullCode: string } }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, scheduleTask?: { __typename?: 'Task', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string }> } | null | undefined }>, billStatus: { __typename?: 'BillStatusDetail', code: Types.BillStatus }, documents: Array<{ __typename?: 'Document', id: string, name: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export const ApprovalSubject_BillFragmentDoc = gql`
    fragment ApprovalSubject_Bill on Bill {
  id
  name
  amountInCents
  blueprintUrl {
    path
  }
  predictedApprovers {
    ...ApproverUserDetail
  }
  project {
    id
    name
  }
  type {
    name
    code
  }
  tradePartner {
    ...Named
  }
  parents {
    id
    accountingNumber
  }
  lineItems {
    id
    projectItem {
      id
      item {
        id
        fullCode
      }
    }
    commitmentLineItem {
      id
    }
    scheduleTask {
      id
      projectItems {
        ...Named
      }
    }
  }
  internalNote
  billStatus: status {
    code
  }
  documents {
    ...Named
    asset {
      ...AssetInfo
    }
  }
}
    ${ApproverUserDetailFragmentDoc}
${NamedFragmentDoc}
${AssetInfoFragmentDoc}`;